import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type SelectedFavouritesState = {
  selectedTeams: string[];
  selectedCompetitions: string[];
  setSelectedTeams: (teams: string[]) => void;
  setSelectedCompetitions: (competitions: string[]) => void;
};

export const useSelectedFavourites = create<SelectedFavouritesState>()(
  persist(
    (set) => ({
      selectedTeams: [],
      selectedCompetitions: [],
      setSelectedTeams: (teams: string[]) => set({ selectedTeams: teams }),
      setSelectedCompetitions: (competitions: string[]) =>
        set({ selectedCompetitions: competitions }),
    }),
    {
      name: 'selected-favourites-storage', // localStorage
    }
  )
);

export default useSelectedFavourites;
